.page {
  height: calc(100% - var(--breadcrumb-wrapper-height));
  padding: 18px 16px 0;
  overflow: auto;
}

.header {
  display: flex;
  justify-content: flex-end;
  min-height: 34px;
  margin-bottom: 8px;
}

.filters {
  display: grid;
  grid-template-columns: repeat(7, minmax(100px, 1fr)) auto;
  gap: 8px;
  align-items: end;
  margin-bottom: 14px;
}

.field {
  min-width: 0;
}

.dateField :global(.input-label) {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--spacing-size-5xs);
  height: 1rem;
  padding-bottom: 5px;
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-default);
}
.dateField :global(.custom .rs-input-group) {
  margin-top: 0;
  margin-bottom: 0;
  height: var(--spacing-size-md);
  box-sizing: border-box;
}
.dateField :global(.custom .rs-input-group.rs-input-group-lg > .rs-input),
.dateField :global(.custom .rs-input-group.rs-input-group-lg > .rs-input-group-addon) {
  height: calc(var(--spacing-size-md) - 2px);
}

.actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  grid-column: 8;
  margin-left: 12px;
}

.table {
  overflow-x: auto;
  padding-top: 16px;
}
.table :global(.clb-table thead th) {
  background-color: #F2F2F2 !important;
  font-size: var(--font-size-default) !important;
}
.table :global(.clb-table th),
.table :global(.clb-table td) {
  white-space: nowrap;
}
.table :global(.clb-table--md tr),
.table :global(.clb-table--md th),
.table :global(.clb-table--md td) {
  height: 48px !important;
  min-height: 48px !important;
  max-height: 48px !important;
}

.selectionColumn {
  width: 32px;
  min-width: 32px;
  max-width: 32px;
  box-sizing: border-box !important;
  padding: 0 6px !important;
}
:global(.clb-table--md) .selectionColumn {
  width: 32px !important;
  min-width: 32px !important;
  max-width: 32px !important;
  padding: 0 6px !important;
}

.problemActionColumn {
  width: 240px;
  min-width: 240px;
  max-width: 240px;
  box-sizing: border-box;
}

.truncatedCell {
  display: block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.channelTags {
  display: flex;
  flex-wrap: nowrap;
  gap: 4px;
}

.channelTag {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  background-color: #D9D9D9;
  border-radius: 999px;
  white-space: nowrap;
}

.statusTag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  height: 32px;
  padding: 0 15px;
  border-radius: 16px;
  white-space: nowrap;
}

.statusOnHold {
  background-color: #D9D9D9;
}

.statusDoing {
  background-color: #F9DC95;
}

.statusAwaitingJustification {
  background-color: #FAD7A0;
}

.statusConcluded {
  background-color: var(--color-feedback-positive-100);
}

.selectionCounter {
  margin-top: 8px;
}

.pagination {
  display: flex;
  justify-content: stretch;
  width: 100%;
  padding: 0 8px;
  box-sizing: border-box;
  margin-top: 16px;
}
.pagination :global(.clb-pagination) {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  width: 100%;
}
.pagination :global(.clb-pagination__itens-per-page),
.pagination :global(.clb-pagination__total-elements) {
  white-space: nowrap;
}
.pagination :global(.clb-pagination__itens-per-page) {
  flex: 0 0 auto;
}
.pagination :global(.clb-pagination__pages) {
  grid-column: 2;
}
.pagination :global(.clb-pagination__total-elements) {
  grid-column: 3;
  justify-self: end;
  flex: none;
}

@media (max-width: 1100px) {
  .filters {
    grid-template-columns: repeat(3, minmax(180px, 1fr));
  }
  .actions {
    grid-column: 1/-1;
    margin-left: 0;
  }
}
@media (max-width: 720px) {
  .filters {
    grid-template-columns: repeat(1, minmax(180px, 1fr));
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */